import beatGIF from '../Projects/beat.gif';
import beat from '../Projects/beat.jpg';
import beat1 from '../Projects/beat1.jpg';
import beat2 from '../Projects/beat2.jpg';
import beat3 from '../Projects/beat3.jpg';
import capGIF from '../Projects/cap.gif';
import cap from '../Projects/cap.jpg';
import cap1 from '../Projects/cap1.jpg';
import cap2 from '../Projects/cap2.jpg';
import cap3 from '../Projects/cap3.jpg';
import musicGIF from '../Projects/music.gif';
import music from '../Projects/music.jpg';
import music1 from '../Projects/music1.jpg';
import music2 from '../Projects/music2.jpg';
import music3 from '../Projects/music3.jpg';
import photonGIF from '../Projects/photon.gif';
import photon from '../Projects/photon.jpg';
import photon1 from '../Projects/photon1.jpg';
import photon2 from '../Projects/photon2.jpg';
import slotGIF from '../Projects/slot.gif';
import slot from '../Projects/slot.jpg';
import slot1 from '../Projects/slot1.jpg';
import slot2 from '../Projects/slot2.jpg';
import slot3 from '../Projects/slot3.jpg';
import ff from '../Projects/ff.jpg'
import ff1 from '../Projects/ff1.jpg'
import ff2 from '../Projects/ff2.jpg'
import ff3 from '../Projects/ff3.jpg'
import ff4 from '../Projects/ff4.jpg'
import weatherGIF from '../Projects/weather.gif'
import weather from '../Projects/weather.jpg'
import weather1 from '../Projects/weather1.jpg'
import weather2 from '../Projects/weather2.jpg'
import weather3 from '../Projects/weather3.jpg'
import twitch from '../Projects/twitch.jpg'
import twitch1 from '../Projects/twitch1.jpg'

export const projectState = () =>{
    return [
        {
            title: "React Music Player",
            mainImg: music,
            gifImg: musicGIF,
            secImg: [music, music1, music2, music3, musicGIF],
            imgDesc: [
                "Initial state. Default volume is set to 20",
                "Select from a library of other songs to play. Background is set to a linear-gradient of the album art",
                "Has loop and shuffle feature",
                "Responsive!",
                "Gif preview"
            ],
            tech: ["JavaScript", "React", "Sass"],
            previewDesc: "A music player app that plays a list of songs by the pianist July.",
            description: "A music player app with functional looping and shuffling songs." + 
            ` All songs link to their respective <a href="https://open.spotify.com/artist/2i66H6Y7BoIctXC5Dfqp2Z" target="_blank">Spotify</a> pages.`
            + " Spotify's song API is only for premium users so these songs are stored locally.",
            urls: {
                github: "https://github.com/JimmyWoooo/music-app",
                live: "https://relaxing-piano-music.netlify.app/"
            }
        },
        {
            title: "Beat Maker",
            mainImg: beat,
            gifImg: beatGIF,
            secImg: [beat, beat1, beat2, beat3, beatGIF],
            imgDesc: [
                "Initial state",
                "Playing. Larger tiles are currently playing a sound.",
                "Paused. Tempo increased. The darker tiles are the tiles that's going to be making the sounds.",
                "Lowered volume. Changed the type of sound that's being played.",
                "Gif preview"
            ],
            tech: ["HTML", "CSS", "JavaScript"],
            previewDesc: "A music website used to create musical beats.",
            description: "Plays up to 3 sounds in a pattern to create an awesome beat." + 
            " Over a hundred combinations of sounds can be created from the vast selection.",
            urls: {
                github: "https://github.com/JimmyWoooo/beat-maker",
                live: "https://jimmy-beat-maker.netlify.app/"
            }
        },
        {
            title: "Capture: Photography Demo site",
            mainImg: cap,
            gifImg: capGIF,
            secImg: [cap, cap1, cap2, cap3, capGIF],
            imgDesc: [
                "Tobias Maguire",
                "Andres Garfiend",
                "Temp page with some dummy text.",
                "Temp page with more dummy text.",
                "Gif preview"
            ],
            tech: ["JavaScript", "React", "Framer Motion", "Styled Components", "CSS"],
            previewDesc: "Demo site to test Framer Motion and transitions.",
            description: "Demo site used to further my knowledge in Framer Motion and a variety of different designs.",
            urls: {
                github: "https://github.com/JimmyWoooo/capture",
                live: "https://jimmy-capture.netlify.app/"
            }
        },
        {
            title: "Photon: Image Searcher",
            mainImg: photon,
            gifImg: photonGIF,
            secImg: [photon, photon1, photon2, photonGIF],
            imgDesc: [
                "Initial state. Random HD pictures displayed from Pexels API.",
                "Looking up pictures of the northern auroras.",
                "Option to load 10 more from the API.",
                "Gif preview"
            ],
            tech: ["HTML", "CSS", "JavaScript"],
            previewDesc: "Looks up HD photos within the Pexel API. Great for stock photo lookup.",
            description: "Looks up HD photos within the Pexel API. Great for stock photo lookup.",
            urls: {
                github: "https://github.com/JimmyWoooo/photon",
                live: "https://jimmy-photon.netlify.app"
            }
        },
        {
            title: "Mini Video Editor",
            mainImg: ff,
            gifImg: ff,
            secImg: [ff, ff1, ff2, ff3, ff4],
            imgDesc: [
                "Looks outdated but there's no need to make it fancy if its main purpose is drag, drop, and click",
                "Ability to drag and drop video files. Will display some useful information about it such as the codecs",
                "Default encoding. Displays how long it took, file size and many more",
                "Ability to drag and drop multiple files to merge. Often times it will be out of order",
                "Ability to rearrange the files in a desired order via drag and drop"
            ],
            tech: ["Java", "JavaFX", "CSS"],
            previewDesc: "A personal video editor used to trim, crop, merge and remove duplicate frames from a video.",
            description: `Personal project made for personal use to trim videos. Built on top of existing software, <a href="https://en.wikipedia.org/wiki/FFmpeg" target="_blank">FFMPEG</a>.` + 
            " Main purpose is so that you don't have to keep typing out the FFMPEG commands but instead, drag, drop and click." +
            " I made this mainly for myself, so the simpler it is, the better.",
            urls: {
                github: "https://github.com/JimmyWoooo/FFVideo-Tool-Kit",
                live: "https://www.youtube.com/watch?v=TXBnSP6tHzg"
            }
        },
        {
            title: "Slots",
            mainImg: slot,
            gifImg: slotGIF,
            secImg: [slot, slot1, slot2, slot3, slotGIF],
            imgDesc: [
                "Initial state",
                "Bet 500 and lost",
                "Lost 4 rounds in a row before winning. Includes a history log of the previous spins",
                "Game Over!",
                "Gif preview"
            ],
            tech: ["Java", "Swing"],
            previewDesc: "A slots emulator built for a school project.",
            description: "Originally a project for school in the form of a console app. Professor was fine with a console " + 
            "application but I decided to make a GUI for it. Background image was also drawn by me.",
            urls: {
                github: "https://github.com/JimmyWoooo/slot",
                live: null
            }
        },
        {
            title: "Weather App",
            gifImg: weatherGIF,
            mainImg: weather,
            secImg: [weather, weather1, weather2, weather3, weatherGIF],
            imgDesc: [
                `Initial state. Animated icons by <a href="https://github.com/maxdow/skycons" target="_blank">Skycons</a>`,
                "Toggle between fahrenheit and celcius. Hourly weather can be opened up for more info",
                "Weekly weather",
                "Searching for a location displays the current time for that location in the hourly section",
                "Gif preview"
            ],
            tech: ["HTML", "CSS", "JavaScript", "EmberJS"],
            previewDesc: "My first project with a framework. Displays current, 24 hour and this week's weather for a location.",
            description: "This was my first attempt at a web dev project. I didn't know anything about how frameworks worked nor media queries"
            + ", so my way of coding it was not optimal.",
            urls: {
                github: "https://github.com/JimmyWoooo/Weather",
                live: "https://jimmy-ember-weather.netlify.app/"
            }
        },
        {
            title: "TwitchRecover",
            gifImg: twitch,
            mainImg: twitch,
            secImg: [twitch, twitch1],
            imgDesc: [
                `Software was created by <a href="https://github.com/daylamtayari" target="_blank">daylamtayari</a>`,
                "My contribution to it when the author went MIA for 2 years.",
            ],
            tech: ["Java"],
            previewDesc: "Contributed to an open source project used by thousands",
            description: "TwitchRecover is an open source program that's used to retrieve links to Twitch VODs."
            + " The original author stopped updating it in 2020 and when Twitch updated their servers, I stepped in and updated his program.",
            urls: {
                github: "https://github.com/TwitchRecover/TwitchRecover/issues/221",
                live: null
            }
        },
        // {
        //     title: "",
        //     gifImg: "",
        //     mainImg: "",
        //     secImg: [],
        //     imgDesc: [
        //         "",
        //         "",
        //         "",
        //         ""
        //     ],
        //     tech: [],
        //     previewDesc: "",
        //     description: "",
        //     urls: {
        //         github: "",
        //         live: ""
        //     }
        // },
    ]
}